const iconDrag = `
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
        <g fill="none" fill-rule="evenodd" transform="rotate(45 4.672 14.328)">
        <g stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round">
          <line x1=".313" x2="14.688" y1="14.688" y2=".313"/>
          <polyline points="3.438 14.688 .313 14.688 .313 11.563"/>
          <polyline points="14.688 3.438 14.688 .313 11.563 .313"/>
          <line x1=".313" x2="14.688" y1=".313" y2="14.688"/>
          <polyline points=".313 3.438 .313 .313 3.438 .313"/>
          <polyline points="11.563 14.688 14.688 14.688 14.688 11.563"/>
        </g>
        <rect width="15" height="15"/>
      </g>
    </svg>
`;

export default iconDrag;
